import { createStyles } from "@app/components/tss/hooks/use-tss-styles";
//@ts-expect-error design system not supported params
export const useStyles = createStyles(({ theme, backgroundSize }) => {
  const { colors, spacing, styles } = theme.busbud;

  const accentColor = colors.accent.primary["500"];
  const thumbSize = spacing(2);
  const trackSize = spacing(1);
  const thumbOffset = `calc((${thumbSize} - ${trackSize}) * -1 / 2)`;
  const trackColor = `linear-gradient(${accentColor},${accentColor})`;

  const trackStyles: React.CSSProperties = {
    height: trackSize,
    borderRadius: styles.rounding.pill
  };

  const thumbStyles: React.CSSProperties = {
    appearance: "none",
    background: accentColor,
    borderRadius: styles.rounding.circle,
    marginTop: thumbOffset,
    border: "none",
    height: thumbSize,
    width: thumbSize,
    boxShadow: styles.shadow.subtle.sm,
    transition: "background .3s ease-in-out"
  };

  return {
    inputRange: {
      padding: spacing(0.75, 0.75, 0.75, 2.5),
      'input[type="range"]': {
        WebkitAppearance: "none",
        fontSize: spacing(1),
        appearance: "none",
        borderRadius: styles.rounding.pill,
        background: colors.background.tertiary.transparent,
        backgroundImage: trackColor,
        backgroundSize: backgroundSize + "% 100%",
        backgroundRepeat: "no-repeat",
        margin: "initial"
      },
      'input[type="range"]:focus': { outline: "none" },
      'input[type="range"]::-webkit-slider-runnable-track': {
        ...trackStyles
      },
      'input[type="range"]::-moz-range-track': {
        ...trackStyles
      },

      'input[type="range"]::-webkit-slider-thumb': {
        WebkitAppearance: "none",
        cursor: "pointer",
        ...thumbStyles
      },

      'input[type="range"]::-moz-range-thumb': {
        ...thumbStyles
      },

      'input[type="range"]:disabled::-webkit-slider-thumb': {
        marginLeft: "96%"
      },

      'input[type="range"]:disabled::-moz-range-thumb': {
        marginLeft: "96%"
      }
    }
  };
});
